import { render, staticRenderFns } from "./approval-explanation.vue?vue&type=template&id=c1a065a4&scoped=true&"
import script from "./approval-explanation.vue?vue&type=script&lang=js&"
export * from "./approval-explanation.vue?vue&type=script&lang=js&"
import style0 from "./approval-explanation.vue?vue&type=style&index=0&id=c1a065a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a065a4",
  null
  
)

export default component.exports